const CITY_COMPONENT_TYPES = [
  'locality',
  'postal_town',
  'administrative_area_level_3',
  'administrative_area_level_2',
];

export function getPlaceCity(place) {
  const components = Array.isArray(place?.address_components) ? place.address_components : [];

  for (const type of CITY_COMPONENT_TYPES) {
    const component = components.find((item) => item.types?.includes(type));
    if (component?.long_name) return component.long_name.trim();
  }

  return cityFromAddress(place?.formatted_address || '');
}

export function getTableCity(table) {
  const explicitCity =
    table?.location?.city ||
    table?.booked?.city ||
    table?.metadata?.city ||
    '';

  return explicitCity.trim() || cityFromAddress(table?.location?.directions || '');
}

export function getRemainingSeats(table) {
  return Math.max(Number(table?.limit || 0) - Number(table?.attendeeCount || 0), 0);
}

export function isTableFull(table) {
  return Number(table?.limit || 0) > 0 && getRemainingSeats(table) === 0;
}

function cityFromAddress(address) {
  const addressParts = String(address)
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);

  for (const part of addressParts) {
    const match = part.match(/\b\d{5}\s+(.+?)(?:\s+\(?[A-Z]{2}\)?)?$/);
    if (match?.[1]) return match[1].trim();
  }

  return '';
}
